// extracted by mini-css-extract-plugin
export default {"section":"Section_section__0XkUm","whatTheCamp":"Section_whatTheCamp__Ur1aT","committee":"Section_committee__wskLN","section__inner":"Section_section__inner__ix6DJ"};